// @ts-nocheck
import React, { useState } from 'react';
import axios from 'axios';
import { URL } from '../../service/Service';
import AuthShell from '../../components/auth/AuthShell';
import { userFriendlyError } from '../../utils/userFriendlyError';

const ResetPassword = () => {
    const [userEmail, setUserEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await axios.post(`${URL}/api/resetpassword`, { userEmail: userEmail.trim().toLowerCase() });
            setMessage('Se o email estiver registado, receberá um link seguro para definir uma nova palavra-passe.');
            setError('');
        } catch (requestError) {
            setError(userFriendlyError(
                requestError?.response?.data,
                'Não foi possível enviar o email de recuperação. Tente novamente mais tarde.',
            ));
            setMessage('');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <AuthShell eyebrow="Recuperação de acesso" title="Recuperar palavra-passe" description="Indique o email associado à sua conta. Enviaremos um link seguro válido durante 15 minutos.">
                    <form className="space-y-6" onSubmit={handleSubmit}>
                        <div>
                            <label htmlFor="email" className="ui-label">
                                Email
                            </label>
                            <div className="mt-1">
                                <input
                                    id="email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    required
                                    value={userEmail}
                                    onChange={e => setUserEmail(e.target.value)}
                                    className="ui-input"
                                    placeholder="nome@empresa.pt"
                                />
                            </div>
                        </div>
                        <div className="flex items-center justify-between"></div>
                        <div>
                            <button
                                type="submit"
                                disabled={submitting}
                                className="ui-button-primary w-full"
                            >
                                {submitting ? 'A enviar…' : 'Enviar link de recuperação'}
                            </button>
                        </div>
                        {message && <div className="ui-alert-success text-center">{message}</div>}
                        {error && <div className="ui-alert-error text-center">{error}</div>}
                        <div className="text-sm text-center">
                            <a href="/login" className="auth-link">
                                Voltar à página de login
                            </a>
                        </div>
                    </form>
        </AuthShell>
    );
}

export default ResetPassword;
